<div [ngClass]="{
    'single-ticket-left-content': this.position === 'left',
    'single-ticket-right-content': this.position === 'right',
    'remove-padding-margin-border': this.noPadding
}">
    <ng-content></ng-content>
</div>
